import React, { Component } from 'react';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/download.svg';
import { ReactComponent as TickIcon } from '../../../assets/svg/expense-tick.svg';
import { ReactComponent as CopyIcon } from '../../../assets/svg/copy-icon.svg';

import { ReactComponent as FileIcon } from '../../../assets/svg/expense-file.svg';
import { ReactComponent as EditIcon } from '../../../assets/svg/Project/edit.svg';
import { ReactComponent as MoreIcon } from '../../../assets/svg/moreoptions2.svg';
import AssignEquipment from '../../components/modals/projects/assignEquipment';
import ReceiveEquipment from '../../components/modals/projects/receiveEquipment';
import AssignMemoryCard from '../../components/modals/projects/assignMemoryCard';
import ReceiveMemoryCard from '../../components/modals/projects/receiveMemoryCard';
import RecordMCBackup from '../../components/modals/projects/recordMCBackup';
import RecordMemCardBackup from '../../components/modals/projects/recordMemCardBackup';
import ReAssignMemoryCards from '../../components/modals/projects/reAssignMemoryCards';

import ShootPageSubHeader from '../../components/mainProject/shootPageSubHeader';
import moment from 'moment';
import jwt_decode from 'jwt-decode';
import ShootPageHeader from '../../components/mainProject/shootPageHeader';
import CreateShoot from '../../components/modals/projects/createShoot';
import _ from 'lodash';
import { withRouter } from '../../../services/withRoute';
import ReAssignEquipments from '../../components/modals/projects/reAssignEquipments';
import { Helmet } from 'react-helmet';

const getEvent = gql`
	query VendorEvent($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			id
			projectId
			name
			projectSlNo
			slNo
			crew {
				count
				role
				managerIds
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			venue
			date
			reportingTime
			projectTitle
			city
			tenantId
			equipments {
				eqId
				qrCode
				status
				isReceived
				userId
				description
				manufacturerId
			}
			unregisteredEqs {
				_id
				status
				manufacturerId
				isReceived
				createdAt
				receivedAt
				description
				quantity
				receivedQuantity
				id
				receivedBy {
					id
					name
				}
				createdBy {
					id
					name
				}
				userId
				userName
			}
			hardDrives {
				_id
				qrCode
				category
				isPurchasedByClient
				status
				size
			}
			memoryCards {
				mcId
				qrCode
				createdAt
				manufacturerId
				type
				size
				ownerId
				userId
				userName
				status
				isReceived
				isEmpty
				isRemapped
				receivedFrom {
					id
					name
				}
				receivedBy {
					id
					name
				}
				receivedAt
				backupLogs {
					hddId
					hddQrCode
					backupSize
					backupPath
					numberOfFiles
					createdBy {
						id
						name
					}
					isVerified
					logId
					verifiedBy {
						id
						name
					}
					files {
						_id
						fileType
						originalFileName
						s3KeyOriginal
						originalFileSizeInMb
					}
				}
			}
		}
	}
`;

const getOnlyMCLogs = gql`
	query VendorEvent($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			memoryCards {
				mcId
				qrCode
				createdAt
				manufacturerId
				type
				size
				ownerId
				userId
				userName
				status
				isReceived
				isEmpty
				receivedFrom {
					id
					name
				}
				receivedBy {
					id
					name
				}
				receivedAt
				backupLogs {
					hddId
					hddQrCode
					backupSize
					backupPath
					numberOfFiles
					createdBy {
						id
						name
					}
					isVerified
					logId
					verifiedBy {
						id
						name
					}
					files {
						_id
						fileType
						originalFileName
						s3KeyOriginal
						originalFileSizeInMb
					}
				}
			}
		}
	}
`;

const getEventMCLogs = gql`
	query EventMcLogSummary($eventId: ID!) {
		eventMcLogSummary(eventId: $eventId) {
			isReceived
			backupLogs {
				createdBy {
					_id
					name
				}
				hddQrCode
				hddId
				isVerified
				verifiedBy {
					_id
					name
				}
				backupSize
				backupPath
				files {
					_id
					fileType
					originalFileName
					s3KeyOriginal
					originalFileSizeInMb
				}
			}
			qrCode
			userName
			userId
			status
			manufacturerId
			type
			size
		}
	}
`;
const getTenantUsersList = gql`
	query TenantUsersList($workspaceIds: [String!]!) {
		tenantUsersList(workspaceIds: $workspaceIds) {
			id
			firstName
			lastName
			email
			isEmailVerified
			phoneNumber
			isShooter
			isSuspended
			displayName
		}
	}
`;
class Shoot extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			projectDetails: {},
			eventDetails: {},
			tenantUsersList: {},
			isTenantsLoading: true,
			isLoading: true,
			showShootAddEditModal: false,
			bride: '',
			groom: '',
			crewDetails: {},
			hardDriveDetails: {},
			equipmentDetails: {},
			showEquimentDropdown: false,
			showEquimentAssignModal: false,
			showEquimentReceiveModal: false,
			showMemoryCardDropdown: false,
			showMemoryCardAssignModal: false,
			showMemoryCardReceiveModal: false,
			mcLogsList: [],
			tempMcLogsList: [],
			mcLogsSummaryError: false,
			mcLogsSummaryErrorMessage: '',
			isMcLogsFetching: false,
			selectedMC: null,
			showRecordMCModal: false,
			mcMoreList: ['Assign', 'Receive'],
			mcFilterList: {},
			mcCurrFilter: 'All',
			mcSearchQuery: '',
			eqCurrFilter: 'All',
		};
		this.equipmentRef = React.createRef();
		this.equipmentDropdownRef = React.createRef();
		this.memoryCardRef = React.createRef();
		this.memoryCardDropdownRef = React.createRef();
	}
	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);

		let userToken = localStorage.getItem('usertoken');
		let decoded = await jwt_decode(userToken);

		this.setState({ userId: decoded.user_id });
		/* let getEventMCLogsVariables = {
			eventId: this.props.match.params.shootID,
		};
		this.getEventMemoryCardLogs(getEventMCLogs, getEventMCLogsVariables); */

		let filters = {
			projectId: this.props.params.projectID,
			vendorEventId: this.props.params.shootID,
			workspaceId: this.props.params.workspaceID,
		};

		let filters2 = {
			workspaceIds: [this.props.params.workspaceID],
		};

		this.getShootInfo(getEvent, filters);
		this.getTenantUsersList(getTenantUsersList, filters2);
	};
	handleReload = () => {
		let filters = {
			projectId: this.props.params.projectID,
			vendorEventId: this.props.params.shootID,
			workspaceId: this.props.params.workspaceID,
		};

		let filters2 = {
			workspaceIds: [this.props.params.workspaceID],
		};

		this.getShootInfo(getEvent, filters);
		this.getTenantUsersList(getTenantUsersList, filters2);
	};
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		if (
			this.equipmentRef.current &&
			!this.equipmentRef.current.contains(event.target) &&
			this.equipmentDropdownRef.current &&
			!this.equipmentDropdownRef.current.contains(event.target)
		) {
			this.setState({
				showEquimentDropdown: false,
			});
		}
		if (
			this.memoryCardRef.current &&
			!this.memoryCardRef.current.contains(event.target) &&
			this.memoryCardDropdownRef.current &&
			!this.memoryCardDropdownRef.current.contains(event.target)
		) {
			this.setState({
				showMemoryCardDropdown: false,
			});
		}
	};
	toggleEquipmentDropDown = (e) => {
		this.setState({
			showEquimentDropdown: !this.state.showEquimentDropdown,
		});
	};
	showEquimentAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-equipment`,
		);
	};
	showEquimentReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-equipment`,
		);
	};
	toggleMemoryCardDropDown = (e) => {
		this.setState({
			showMemoryCardDropdown: !this.state.showMemoryCardDropdown,
		});
	};
	showMemoryCardAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardAssignModal: !this.state.showMemoryCardAssignModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardAssignModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showMemoryCardReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardReceiveModal: !this.state.showMemoryCardReceiveModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardReceiveModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showRecordABackUpModal = (e) => {
		this.setState({
			showRecordABackUpModal: !this.state.showRecordABackUpModal,
		});
	};
	showReAssignMemoryCards = (e) => {
		this.setState({
			showReAssignMemoryCards: !this.state.showReAssignMemoryCards,
		});
	};

	showReAssignEquipments = (e) => {
		this.setState({
			showReAssignEquipments: !this.state.showReAssignEquipments,
		});
	};

	showRecordMCModal = (e) => {
		this.setState({
			showRecordMCModal: !this.state.showRecordMCModal,
		});
	};
	mcDetailsUpdated = (isWithoutLoading = null) => {
		let getEventMCLogsVariables = {
			vendorEventId: this.props.params.shootID,
			projectId: this.props.params.projectID,
			workspaceId: this.props.params.workspaceID,
		};
		this.getEventMemoryCardLogs(getOnlyMCLogs, getEventMCLogsVariables, isWithoutLoading);
	};

	showShootAddEditModal = (e) => {
		this.setState({
			showShootAddEditModal: !this.state.showShootAddEditModal,
		});
	};

	handleOnCLickMC = (mc) => {
		// if (
		// 	mc.status === 'backupPending' ||
		// 	mc.status === 'verificationPending' ||
		// 	mc.status === 'formatPending'
		// ) {
		this.setState({
			showRecordMCModal: true,
			selectedMC: mc,
		});
		// }
	};

	onMcSearch = (searchQuery) => {
		this.setState(
			{
				mcSearchQuery: searchQuery,
			},
			() => {
				let mcSearchQuery = this.state.mcSearchQuery;
				let mcLogsList = _.cloneDeep(this.state.tempMcLogsList);
				let mcFilterList = _.cloneDeep(this.state.mcFilterList);
				if (_.size(mcSearchQuery.trim()) > 0) {
					mcLogsList = _.filter(mcLogsList, (item, index) => {
						return (
							item.qrCode.trim().toLowerCase().includes(mcSearchQuery.trim()) ||
							item.type
								.trim()

								.includes(mcSearchQuery.trim()) ||
							item.userName
								.trim()

								.includes(mcSearchQuery.trim())
						);
					});
					mcFilterList = { All: [] };
					_.forEach(mcLogsList, (item, index) => {
						mcFilterList.All.push(item);
						if (!_.has(mcFilterList, item.userName)) {
							mcFilterList[item.userName] = [];
						}
						mcFilterList[item.userName].push(item);
					});
				} else {
					mcFilterList = { All: [] };
					_.forEach(mcLogsList, (item, index) => {
						mcFilterList.All.push(item);
						if (!_.has(mcFilterList, item.userName)) {
							mcFilterList[item.userName] = [];
						}
						mcFilterList[item.userName].push(item);
					});
				}

				this.setState({
					mcLogsList,
					mcFilterList,
				});
			},
		);
	};

	mcOnChangeFIlter = (key) => {
		this.setState({
			mcCurrFilter: key,
		});
	};

	eqOnChangeFIlter = (key) => {
		this.setState({
			eqCurrFilter: key,
		});
	};

	renderMemoryCardsContainer = () => {
		return (
			<div className="column-three-top">
				<h3 style={{ backgroundColor: 'none', zIndex: 2 }}>
					Memory Cards
					{` (${_.size(this.state.eventDetails.memoryCards)})`}
					<b>
						<span
							onClick={(e) =>
								window.open(
									`https://pdf.huemn.com/memory-cards/${this.props.params.vendorID}/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
								)
							}
							style={{ marginRight: 40 }}
						>
							<DownloadIcon />
						</span>

						<span
							onClick={(e) => this.toggleMemoryCardDropDown(e)}
							ref={this.memoryCardRef}
						>
							<MoreIcon />
							{this.state.showMemoryCardDropdown ? (
								<div className="dropdown" ref={this.memoryCardDropdownRef}>
									<a onClick={(e) => this.showMemoryCardAssignModal(e)}>Assign</a>
									<a onClick={(e) => this.showMemoryCardReceiveModal(e)}>
										Receive
									</a>
									<a onClick={(e) => this.showRecordABackUpModal(e)}>
										Record a Backup
									</a>
									<a onClick={(e) => this.showReAssignMemoryCards(e)}>
										Re Assign Memory Cards
									</a>
								</div>
							) : (
								''
							)}
						</span>
					</b>
				</h3>
				<div className="shoot-page-sub-header-container" style={{ zIndex: 1 }}>
					<div
						className={
							'sub-filter-item' + (this.state.mcCurrFilter === 'All' ? ' active' : '')
						}
						onClick={() => {
							if (this.state.mcCurrFilter !== 'All') {
								this.mcOnChangeFIlter('All');
							}
						}}
					>
						<span className="title">{'All'}</span>
						<span className="title">{_.size(this.state.eventDetails.memoryCards)}</span>
					</div>

					{_.map(
						_.groupBy(
							_.sortBy(this.state.eventDetails.memoryCards, ['isReceived']),
							'userId',
						),
						(item, userId) => {
							return (
								<div
									className={
										'sub-filter-item' +
										(this.state.mcCurrFilter === userId ? ' active' : '')
									}
									onClick={() => {
										if (this.state.mcCurrFilter !== userId) {
											this.mcOnChangeFIlter(userId);
										}
									}}
								>
									<span className="title">
										{_.size(
											_.filter(this.state.tenantUsersList, {
												id: userId,
											}),
										) > 0
											? _.has(
													_.filter(this.state.tenantUsersList, {
														id: userId,
													})[0],
													'displayName',
											  ) &&
											  _.filter(this.state.tenantUsersList, {
													id: userId,
											  })[0]['displayName'] != null
												? _.filter(this.state.tenantUsersList, {
														id: userId,
												  })[0]['displayName']
												: _.filter(this.state.tenantUsersList, {
														id: userId,
												  })[0].firstName +
												  ' ' +
												  _.filter(this.state.tenantUsersList, {
														id: userId,
												  })[0].lastName
											: ''}
									</span>
									<span className="title">{_.size(item)}</span>
								</div>
							);
						},
					)}
				</div>

				<div className="mc-events-logs-table-container">
					<table>
						<thead>
							<tr>
								<th>SNO</th>
								<th>CARD TYPE</th>
								<th>SERIAL NO</th>
								<th>ASSIGNED TO</th>
								<th>RECEIVED</th>
								<th>DATA SIZE (GB)</th>

								{_.map(this.state.eventDetails.hardDrives, (hdd, key) => {
									return (
										<th>
											<div style={{ display: 'flex' }}>
												<div
													style={
														hdd.category === 'working'
															? {
																	background: '#03a0ff',
																	width: '10px',
																	height: '10px',
																	borderRadius: '25px',
																	margin: '2px 5px',
															  }
															: {
																	background: '#fe2c2b',
																	width: '10px',
																	height: '10px',
																	borderRadius: '25px',
																	margin: '5px',
															  }
													}
												></div>
												{hdd.qrCode}
											</div>
										</th>
									);
								})}

								{/* <th>VERIFIED</th> */}
							</tr>
						</thead>
						<tbody>
							{_.map(
								this.state.mcCurrFilter === 'All'
									? _.sortBy(this.state.eventDetails.memoryCards, [
											'isReceived',
											'status',
											'isEmpty',
									  ])
									: _.filter(
											_.sortBy(this.state.eventDetails.memoryCards, [
												'isReceived',
												'status',
												'isEmpty',
											]),
											{
												userId: this.state.mcCurrFilter,
											},
									  ),

								(mc, index) => {
									return (
										<tr
											key={`${index}329dufjiodiplk`}
											onClick={() => {
												if (
													mc.isReceived == true &&
													_.has(mc, 'isRemapped') &&
													(mc.isRemapped === false ||
														mc.isRemapped === null)
												) {
													this.handleOnCLickMC(mc);
												}
											}}
											style={{
												backgroundColor:
													mc.status === 'ready' ? '#333333' : '',
												textDecoration: mc.isRemapped ? 'line-through' : '',
												cursor: mc.status === 'ready' ? '' : 'pointer',
												color: mc.isRemapped ? 'white' : '',
											}}
										>
											<td>{index + 1}</td>
											<td>
												{mc.type ? mc.type.toUpperCase() : ''}{' '}
												{mc.size ? `(${mc.size})GB` : ''}
											</td>
											<td>
												{_.has(mc, 'qrCode')
													? mc.qrCode
														? mc.qrCode.toUpperCase()
														: ''
													: ''}
											</td>
											<td>
												{mc.userId
													? mc.userName
														? mc.userName.toUpperCase()
														: ''
													: ''}
											</td>
											<td>
												{mc.isReceived ? (
													<TickIcon />
												) : _.size(
														_.filter(
															this.state.eventDetails.memoryCards,
															{
																isReceived: true,
															},
														),
												  ) > 0 ? (
													<div className="notReceivedMemoryCard"></div>
												) : (
													''
												)}
											</td>
											<td>
												<div style={{ display: 'flex' }}>
													{mc.isReceived ? (
														mc.isEmpty ? (
															'Empty'
														) : _.has(mc, 'backupLogs') &&
														  _.size(mc.backupLogs) > 0 &&
														  _.has(mc.backupLogs[0], 'backupSize') ? (
															mc.backupLogs[0]['backupSize']
														) : (
															<span
																style={{
																	color: '#fdb946',
																}}
															>
																Not Copied
															</span>
														)
													) : (
														''
													)}

													{mc.isEmpty ? (
														_.has(mc, 'backupLogs') &&
														_.size(mc.backupLogs) >= 1 &&
														_.size(mc.backupLogs) ===
															_.size(
																_.filter(mc.backupLogs, {
																	isVerified: true,
																}),
															) ? (
															<TickIcon />
														) : (
															<div className="pendingMemoryCard">
																{' '}
															</div>
														)
													) : _.has(mc, 'backupLogs') &&
													  _.size(mc.backupLogs) ? (
														_.map(
															mc.backupLogs,
															(memoryCard) => memoryCard.backupSize,
														).every(
															(val) =>
																val === mc.backupLogs[0].backupSize,
														) ? (
															''
														) : (
															<div className="notReceivedMemoryCard"></div>
														)
													) : (
														''
													)}
												</div>
											</td>

											{_.map(
												this.state.eventDetails.hardDrives,
												(hd, index) => {
													let backupLog = _.filter(mc.backupLogs, {
														hddQrCode: hd.qrCode,
													});

													return (
														<td>
															<div
																style={{
																	display: 'flex',
																}}
															>
																{mc.isReceived === false ||
																mc.isEmpty ? (
																	''
																) : _.size(backupLog) > 0 ? (
																	<TickIcon />
																) : (
																	<div className="pendingMemoryCard">
																		{' '}
																	</div>
																)}
																{mc.isReceived === false ||
																mc.isEmpty ? (
																	''
																) : _.size(backupLog) > 0 &&
																  backupLog[0].isVerified ? (
																	<TickIcon />
																) : (
																	<div className="pendingMemoryCard">
																		{' '}
																	</div>
																)}
															</div>
														</td>
													);
												},
											)}
											{/* <td>
											{mc.backupLogs &&
											_.size(mc.backupLogs) > 0 &&
											_.every(mc.backupLogs, {
												isVerified: true,
											}) ? (
												<TickIcon />
											) : null}
										</td> */}
										</tr>
									);
								},
							)}
						</tbody>
					</table>
				</div>
			</div>
		);
	};

	renderEquipmentContainer = () => {
		let unregisteredEqs = [];
		_.map(this.state.eventDetails.unregisteredEqs, (equipment) => {
			let receivedQuantity = equipment.receivedQuantity ? equipment.receivedQuantity : 0;
			for (let index = 0; index < equipment.quantity; index++) {
				if (equipment.receivedQuantity > 0) {
					unregisteredEqs.push({ ...equipment, isReceived: true });
					receivedQuantity = receivedQuantity - 1;
				} else unregisteredEqs.push(equipment);
			}
		});

		let equipmentsList = _.concat(this.state.eventDetails.equipments, unregisteredEqs);
		return (
			<div className="column-three-bottom">
				<h3 style={{ backgroundColor: 'none', zIndex: 2 }}>
					Equipments
					<b>
						<span
							onClick={(e) =>
								window.open(
									`https://pdf.huemn.com/equipment/${
										this.props.params.vendorID
									}/${this.props.params.workspaceID}/${
										this.props.params.projectID
									}/${this.props.params.shootID}${
										this.state.eqCurrFilter == 'All'
											? ''
											: '?assignedTo=' + this.state.eqCurrFilter
									}`,
								)
							}
							style={{ marginRight: 40 }}
						>
							<DownloadIcon />
						</span>

						<span
							onClick={(e) => this.toggleEquipmentDropDown(e)}
							ref={this.equipmentRef}
						>
							<MoreIcon />
							{this.state.showEquimentDropdown ? (
								<div className="dropdown" ref={this.equipmentDropdownRef}>
									<a onClick={(e) => this.showEquimentAssignModal(e)}>Assign</a>
									<a onClick={(e) => this.showEquimentReceiveModal(e)}>Receive</a>
									<a onClick={(e) => this.showReAssignEquipments(e)}>
										Re Assign Equipments
									</a>
								</div>
							) : (
								''
							)}
						</span>
					</b>
				</h3>

				<div className="shoot-page-sub-header-container" style={{ zIndex: 1 }}>
					<div
						className={
							'sub-filter-item' + (this.state.eqCurrFilter === 'All' ? ' active' : '')
						}
						onClick={() => {
							if (this.state.eqCurrFilter !== 'All') {
								this.eqOnChangeFIlter('All');
							}
						}}
					>
						<span className="title">{'All'}</span>
						<span className="title">{_.size(equipmentsList)}</span>
					</div>

					{_.map(
						_.groupBy(_.sortBy(equipmentsList, ['isReceived']), 'userId'),
						(item, userId) => {
							return (
								<div
									className={
										'sub-filter-item' +
										(this.state.eqCurrFilter === userId ? ' active' : '')
									}
									onClick={() => {
										if (this.state.eqCurrFilter !== userId) {
											this.eqOnChangeFIlter(userId);
										}
									}}
								>
									<span className="title">
										{_.size(
											_.filter(this.state.tenantUsersList, {
												id: userId,
											}),
										) > 0
											? _.filter(this.state.tenantUsersList, {
													id: userId,
											  })[0].firstName +
											  ' ' +
											  _.filter(this.state.tenantUsersList, {
													id: userId,
											  })[0].lastName
											: ''}
									</span>
									<span className="title">{_.size(item)}</span>
								</div>
							);
						},
					)}
				</div>

				<div className="hdd-item ">
					<div className="column column-20w">
						<span>SNo</span>
						<span>description</span>
						<span>Serial ID</span>
						<span>EQ id</span>
						<span>assigned to</span>
						<span>Rec</span>
					</div>

					{_.size(equipmentsList) > 0 ? (
						_.map(
							this.state.eqCurrFilter === 'All'
								? _.orderBy(equipmentsList, 'isReceived')
								: _.filter(_.orderBy(equipmentsList, 'isReceived'), {
										userId: this.state.eqCurrFilter,
								  }),
							(equipment, key) => {
								return (
									<div className="hitem column-20w">
										<span>{key + 1}</span>
										<span>
											{_.has(equipment, 'description')
												? equipment.description
												: ''}
										</span>
										<span>
											{_.has(equipment, 'manufacturerId')
												? equipment.manufacturerId
												: ''}
										</span>
										<span>
											{_.has(equipment, 'qrCode')
												? equipment.qrCode
												: 'Unregistered'}
										</span>
										<span>
											{_.has(equipment, 'userId') &&
											_.size(
												_.filter(this.state.tenantUsersList, {
													id: equipment.userId,
												}),
											) > 0
												? _.filter(this.state.tenantUsersList, {
														id: equipment.userId,
												  })[0].firstName +
												  ' ' +
												  _.filter(this.state.tenantUsersList, {
														id: equipment.userId,
												  })[0].lastName
												: ''}
										</span>
										<span>
											{_.has(equipment, 'isReceived') &&
											equipment.isReceived &&
											equipment.isReceived == true ? (
												<TickIcon />
											) : _.size(
													_.filter(this.state.eventDetails.equipments, {
														isReceived: true,
													}),
											  ) > 0 ? (
												<div className="notReceivedMemoryCard"></div>
											) : (
												''
											)}
										</span>
										{/* <span style={{ backgroundColor: '#F8532B' }}>
														Damaged
													</span> */}
									</div>
								);
							},
						)
					) : (
						<span className="no-items">No Equipments</span>
					)}
				</div>
			</div>
		);
	};

	renderRightSideContainer = () => {
		return (
			<div className="column-three">
				{this.renderMemoryCardsContainer()}
				{this.renderEquipmentContainer()}
			</div>
		);
	};

	copyCrewForEvent = (crewDetails) => {
		let photoText = _.compact(
			_.map(crewDetails, (crew) =>
				crew.name !== '' && crew.role !== 'cinematographer'
					? ` ${crew.name} (${
							_.has(crew, 'subRole') ? crew.subRole.charAt(0).toUpperCase() : ''
					  }${
							crew.role === 'cinematographer'
								? 'V'
								: crew.role.charAt(0).toUpperCase()
					  })${crew.isManager ? ' (Shoot Manager)' : ''}`
					: '',
			),
		).toString();

		let videoText = _.compact(
			_.map(crewDetails, (crew) =>
				crew.name !== '' && crew.role === 'cinematographer'
					? ` ${crew.name} (${
							_.has(crew, 'subRole') ? crew.subRole.charAt(0).toUpperCase() : ''
					  }${
							crew.role === 'cinematographer'
								? 'V'
								: crew.role.charAt(0).toUpperCase()
					  })${crew.isManager ? ' (Shoot Manager)' : ''}`
					: '',
			),
		).toString();

		let message = `${this.state.eventDetails.projectTitle}(PJ-${
			this.state.eventDetails.projectSlNo
		}) - ${this.state.eventDetails.name}(ST-${this.state.eventDetails.slNo}) \nPlace : ${
			this.state.eventDetails.venue === null ? '' : this.state.eventDetails.venue + ','
		} ${this.state.eventDetails.city} \nDate: ${moment(
			this.state.eventDetails.date,
			'YYYYMMDD',
		).format('DD MMM YYYY')} ${
			this.state.eventDetails.reportingTime ? this.state.eventDetails.reportingTime : ''
		} \nPhoto Team : ${photoText} \nVideo Team : ${videoText}`;

		navigator.clipboard.writeText(message);
	};

	render() {
		let filteredMcList = [];
		if (this.state.isMcLogsFetching === false) {
			filteredMcList = this.state.mcFilterList[this.state.mcCurrFilter];
		}

		let crewDetails = [];

		_.map(this.state.eventDetails.crewNew, (crew) => {
			if (crew.isCustomUser !== false) {
				_.forEach(crew.roles, (roles) => {
					let found = undefined;
					let dateOverlap = false;
					let dateTimeOverlap = false;
					let name = '';
					let isManager;
					let role = null;
					let subRole = null;
					let phoneNumber = '';
					found = _.find(this.state.tenantUsersList, { id: crew.userId });
					if (crew.userId === null) {
						name = 'unassigned';
						phoneNumber = '';
						role = roles.role;
						isManager = false;
						subRole = roles.subRole;
					} else if (found) {
						name =
							_.has(found, 'displayName') && found.displayName != null
								? found.displayName
								: `${found.firstName ? found.firstName : ''}${' '}${
										found.lastName ? found.lastName : ''
								  }`;
						phoneNumber = found.phoneNumber;
						role = roles.role;
						isManager = crew.isManager ? false : crew.isManager;
						subRole = roles.subRole;
					}

					found = undefined;

					found = undefined;

					if (crew.userId !== null && found) {
						dateTimeOverlap = true;
					}
					let data = {
						id: crew.userId,
						name,
						isManager,
						role,
						subRole,
						phoneNumber,
					};
					crewDetails.push(data);
				});
			}
			return crew;
		});
		return (
			<>
				{this.state.isLoading || this.state.isTenantsLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div className="shoot-table">
						<Helmet>
							<meta charSet="utf-8" />
							<title>
								{`${this.props.params.workspaceID} - ${this.state.eventDetails.slNo}`}
							</title>
						</Helmet>
						<div className="column-one">
							<div className="column-one-top">
								<a
								//href={` https://app.huemn.com/${this.props.params.workspaceID}/projects/project/${this.props.params.projectID}/shoots`}
								//target="_blank"
								>
									<h3>
										Event Details
										{/* <span onClick={(e) => this.showShootAddEditModal()}>
											<EditIcon />
										</span> */}
									</h3>
								</a>
								<div className="item">
									<span>Project</span>
									<b>
										{this.state.eventDetails.projectTitle} (PJ-
										{this.state.eventDetails.projectSlNo})
									</b>
								</div>
								<div className="item">
									<span>Event</span>
									<b>
										{this.state.eventDetails.name} (ST-
										{this.state.eventDetails.slNo})
									</b>
								</div>
								<div className="item">
									<span>Date</span>
									<b>
										{this.state.eventDetails.date &&
										this.state.eventDetails.date !== null
											? moment(
													this.state.eventDetails.date,
													'YYYYMMDD',
											  ).format('DD MMM YYYY')
											: '-'}
									</b>
								</div>
								<div className="item">
									<span>Reporting Time</span>
									<b>
										{this.state.eventDetails.reportingTime &&
										this.state.eventDetails.reportingTime !== null
											? this.state.eventDetails.reportingTime
											: '-'}
									</b>
								</div>
								<div className="item">
									<span>City</span>
									<b>{this.state.eventDetails.city}</b>
								</div>
								<div className="item">
									<span>Venue</span>
									<b>{this.state.eventDetails.venue}</b>
								</div>
							</div>
							<div className="column-one-center">
								<h3>
									<a
										href={` https://app.huemn.com/${this.props.params.workspaceID}/projects/project/${this.props.params.projectID}/shoots`}
										target="_blank"
										style={{ color: '#e4e5e6' }}
									>
										Crew{` (${_.size(crewDetails)})`}
									</a>
									{/* <span
										onClick={(e) => this.showShootAddEditModal()}
										style={{ marginRight: '80px' }}
									>
										<EditIcon />
									</span> */}
									<span
										onClick={(e) => this.copyCrewForEvent(crewDetails)}
										style={{ marginRight: '40px' }}
									>
										<CopyIcon />
									</span>
									<span
										onClick={(e) =>
											window.open(
												`https://pdf.huemn.com/shoot-crew/${this.props.params.vendorID}/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
											)
										}
									>
										<DownloadIcon />
									</span>
								</h3>

								<>
									{_.size(crewDetails) == 0 ? (
										<span className="no-items">No Crew</span>
									) : (
										<>
											{_.size(
												_.filter(crewDetails, {
													role: 'photographer',
												}),
											) > 0 ||
											_.size(
												_.filter(crewDetails, {
													role: 'cinematographer',
												}),
											) > 0 ? (
												<div className="hdd-item">
													<div className="column">
														<span>SNo</span>
														<span
															style={{
																width: '90%',
															}}
														>
															Name
														</span>
														<span>Contact</span>
													</div>
													{_.map(
														_.orderBy(crewDetails, 'isManager', 'desc'),

														(crew, k) => {
															if (crew.name !== '')
																return (
																	<div className="hitem">
																		<span>{k + 1}</span>
																		<span
																			style={{
																				width: '90%',
																			}}
																		>
																			{crew.name}{' '}
																			{_.has(crew, 'subRole')
																				? `(${crew.subRole
																						.charAt(0)
																						.toUpperCase()}${
																						crew.role ===
																						'cinematographer'
																							? 'V'
																							: crew.role
																									.charAt(
																										0,
																									)
																									.toUpperCase()
																				  })`
																				: ''}{' '}
																			{crew.isManager
																				? '(Shoot Manager)'
																				: ''}
																		</span>
																		<span>
																			{crew.phoneNumber}
																		</span>
																	</div>
																);
														},
													)}
												</div>
											) : (
												<span className="no-items">No Crew</span>
											)}
										</>
									)}
								</>
							</div>
							<div className="column-one-bottom">
								<a
									href={`https://app.huemn.com/${this.props.params.workspaceID}/projects/project/${this.props.params.projectID}/hard-drives`}
									target="_blank"
								>
									<h3>
										Hard Drives
										{` (${_.size(this.state.eventDetails.hardDrives)})`}
									</h3>
								</a>
								{_.size(this.state.eventDetails.hardDrives) > 0 ? (
									<div className="hdd-item ">
										<table className="hdd-table">
											<thead>
												<tr>
													<td>Sl.No</td>
													<td>QR Code</td>
													<td>Size</td>
													<td>Category</td>
													<td>Status</td>
													{/* <td>Location</td> */}
												</tr>
											</thead>
											<tbody>
												{_.map(
													this.state.eventDetails.hardDrives,
													(hardDrive, key) => {
														return (
															<tr>
																<td>{key + 1}</td>
																<td>
																	<div
																		style={{
																			display: 'flex',
																		}}
																	>
																		<div
																			style={
																				hardDrive.category ===
																				'working'
																					? {
																							background:
																								'#03a0ff',
																							width: '10px',
																							height: '10px',
																							borderRadius:
																								'25px',
																							margin: '5px',
																					  }
																					: {
																							background:
																								'#fe2c2b',
																							width: '10px',
																							height: '10px',
																							borderRadius:
																								'25px',
																							margin: '5px',
																					  }
																			}
																		></div>
																		{hardDrive.qrCode}
																	</div>
																</td>
																<td>
																	{hardDrive.size}
																	TB
																</td>
																<td>{hardDrive.category}</td>
																<td>{hardDrive.status}</td>
																{/* <td>{hardDrive.location}</td> */}
															</tr>
														);
													},
												)}
											</tbody>
										</table>
										{/* <div className="column column-20w">
											<span>SNo</span>
											<span>QR Code</span>
											<span>Size</span>
											<span>Category</span>
											<span>Status</span> <span>Location</span>
										</div>
										{_.map(
											this.state.eventDetails.hardDrives,
											(hardDrive, key) => {
												return (
													<div className="hitem column-20w">
														<span>{key + 1}</span>
														<span>{hardDrive.qrCode}</span>
														<span>{hardDrive.size}TB</span>
														<span>{hardDrive.category}</span>
														<span>{hardDrive.status}</span>
														<span>{hardDrive.location}</span>
													</div>
												);
											},
										)} */}
									</div>
								) : (
									<span className="no-items">No hard Drives</span>
								)}
							</div>
						</div>

						{this.renderRightSideContainer()}
					</div>
				)}

				{this.state.showEquimentAssignModal === true ? (
					<AssignEquipment
						handleClose={(e) => [this.showEquimentAssignModal(e), this.handleReload(e)]}
						show={this.state.showEquimentAssignModal}
						close={(e) => this.showEquimentAssignModal(e)}
						projectTitle={`${this.state.bride !== null ? this.state.bride : ''} ${
							this.state.groom !== null || this.state.groom !== '' ? ' x ' : ''
						} ${this.state.groom !== null ? this.state.groom : ''}`}
						eventTitle={this.state.eventDetails.name}
						crew={this.state.crewDetails}
						{...this.props}
					/>
				) : null}
				{this.state.showEquimentReceiveModal === true ? (
					<ReceiveEquipment
						handleClose={(e) => [
							this.showEquimentReceiveModal(e),
							this.handleReload(e),
						]}
						show={this.state.showEquimentReceiveModal}
						close={(e) => this.showEquimentReceiveModal(e)}
						projectTitle={`${this.state.bride !== null ? this.state.bride : ''} ${
							this.state.groom !== null && this.state.groom !== null ? ' x ' : ''
						} ${this.state.groom !== null ? this.state.groom : ''}`}
						eventTitle={this.state.eventDetails.name}
						crew={this.state.crewDetails}
						{...this.props}
					/>
				) : null}
				{this.state.showMemoryCardAssignModal === true ? (
					<AssignMemoryCard
						handleClose={(e) => [this.showMemoryCardAssignModal(e)]}
						show={this.state.showMemoryCardAssignModal}
						close={(e) => this.showMemoryCardAssignModal(e)}
						mcDetailsUpdated={this.mcDetailsUpdated}
						eventDetails={this.state.eventDetails}
					/>
				) : null}
				{this.state.showMemoryCardReceiveModal === true ? (
					<ReceiveMemoryCard
						handleClose={(e) => [this.showMemoryCardReceiveModal(e)]}
						show={this.state.showMemoryCardReceiveModal}
						close={(e) => this.showMemoryCardReceiveModal(e)}
						mcDetailsUpdated={this.mcDetailsUpdated}
						eventDetails={this.state.eventDetails}
					/>
				) : null}
				{this.state.showRecordMCModal === true ? (
					<RecordMCBackup
						selectedMC={this.state.selectedMC}
						handleClose={(e) => [this.showRecordMCModal(e)]}
						show={this.state.showRecordMCModal}
						close={(e) => this.showRecordMCModal(e)}
						onMCBackedUp={() => this.mcDetailsUpdated(true)}
						mcDetailsUpdated={() => this.mcDetailsUpdated()}
						hardDrivesList={this.state.eventDetails.hardDrives}
					/>
				) : null}
				{this.state.showReAssignEquipments === true ? (
					<ReAssignEquipments
						handleClose={(e) => [this.showReAssignEquipments()]}
						show={this.state.showReAssignEquipments}
						close={(e) => this.showReAssignEquipments()}
						// qrCode={this.state.selectedMC.qrCode}
						// selectedMC={this.state.selectedMC}
						equipmentsList={this.state.eventDetails.equipments}
						unregisteredEqs={this.state.eventDetails.unregisteredEqs}
						onMCBackedUp={() => this.mcDetailsUpdated(true)}

						//backupForModal={this.state.backupForModal}
					/>
				) : this.state.showReAssignMemoryCards === true ? (
					<ReAssignMemoryCards
						handleClose={(e) => [this.showReAssignMemoryCards()]}
						show={this.state.showReAssignMemoryCards}
						close={(e) => this.showReAssignMemoryCards()}
						// qrCode={this.state.selectedMC.qrCode}
						// selectedMC={this.state.selectedMC}
						memoryCardsList={this.state.eventDetails.memoryCards}
						onMCBackedUp={() => this.mcDetailsUpdated(true)}
						recordType={'record'}

						//backupForModal={this.state.backupForModal}
					/>
				) : this.state.showRecordABackUpModal === true ? (
					<RecordMemCardBackup
						handleClose={(e) => [this.showRecordABackUpModal()]}
						show={this.state.showRecordABackUpModal}
						close={(e) => this.showRecordABackUpModal()}
						// qrCode={this.state.selectedMC.qrCode}
						// selectedMC={this.state.selectedMC}
						memoryCardsList={this.state.eventDetails.memoryCards}
						onMCBackedUp={() => this.mcDetailsUpdated(true)}
						recordType={'record'}

						//backupForModal={this.state.backupForModal}
					/>
				) : this.state.showShootAddEditModal === true ? (
					<CreateShoot
						handleClose={() => this.showShootAddEditModal()}
						show={this.state.showShootAddEditModal}
						close={() =>
							this.setState({ showShootAddEditModal: false }, () =>
								this.handleReload(),
							)
						}
						data={this.state.eventDetails}
						activeShootID={this.state.eventDetails.id}
						projectTitle={this.state.eventDetails.projectTitle}
						tenantId={this.state.eventDetails.tenantId}
						tenantUsersList={_.filter(this.state.tenantUsersList, {
							isEmailVerified: true,
						})}
						shootDetailsUpdated={this.handleReload}
						projectId={this.state.eventDetails.projectId}
						isTenantCreate={false} //this.state.selectedProjectID === null}
					/>
				) : null}
			</>
		);
	}
}

export default withRouter(Shoot);
